/** Secondary action (e.g. "See how it works"): a quiet pill that sits beside the filled primary button. */
export const secondaryButtonClass = (dark: boolean) =>
    `rounded-full ${dark
        ? "bg-slate-900/60 border-slate-700 text-slate-200 hover:bg-slate-800 hover:text-white"
        : "bg-white/70 border-slate-300 text-slate-700 hover:bg-white"
    }`;
